<template>
  <div class="no-data">暂无数据</div>
</template>

<script>
export default {
  data () {
    return {};
  }
};
</script>

<style scoped lang="scss">
.no-data {
  font-size: 14px;
  color: #5e6d82;
}
</style>
